import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Affectation } from "../../core/model/affectation";
import { AffectationService } from "../../core/service/affectation.service";

@Component({
  selector: "app-edit-affectation",
  templateUrl: "./edit-affectation.component.html",
  styleUrls: ["./edit-affectation.component.scss"],
})
export class EditAffectationComponent implements OnInit {
  @Input()
  set affectation(value: Affectation) {
    if (value) {
      this._affectation = { ...value };
      this.cdr.detectChanges();
    }
  }
  get affectation(): Affectation {
    return this._affectation;
  }

  private _affectation: Affectation;

  form2: FormGroup;
  pressButton: Boolean = false;
  loading = false;

  constructor(
    private _affectationService: AffectationService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      profileCode: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._affectationService
      .update(this.affectation)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.affectation);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
